import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Home from './containers/HomeContainer';
import HistoricContainer from './containers/HistoricContainer'
import EmailAccountContainer from './containers/EmailAccountsContainer';
import UsersContainer from './containers/UsersContainer';
import ReportContainer from './containers/ReportContainer';
import CampaignsCreateForm from './components/CampaignsCreateForm';
import DoNotDisturbContainer from './containers/DoNotDisturbContainer';
import { Redirect } from 'react-router-dom';
import NoAuth from './containers/NoAuth';
import FullWidthTabs from "./components/NavBar";

const Routes = () => {
  return (
    <div>
      <FullWidthTabs />
      <Switch>
      <Route exact path='/' component={Home} />
      <Route exact path='/NewCampaign' component={CampaignsCreateForm} />
      <Route exact path='/Users' component={UsersContainer} />
      <Route exact path='/Reports' component={ReportContainer} />
      <Route exact path='/Historic' component={HistoricContainer} />
      <Route exact path='/EmailAccounts' component={EmailAccountContainer} />
      <Route exact path='/DoNotDisturb' component={DoNotDisturbContainer} />
      <Route exact path='/NoAuth' component={NoAuth} />
      <Route render={() => <Redirect to={{pathname: "/"}} />} />
    </Switch>
    </div>
  );
};

export default Routes;
